import { type ReactNode } from 'react'
import { Button } from '@/components/Button'
import { useToggleButtonGroup } from './ToggleButtonGroup'
import type { IconName } from '@/components/Icon'

interface ToggleButtonProps {
	value: string
	label?: string
	iconLeft?: IconName
	iconRight?: IconName
	iconOnly?: IconName
	disabled?: boolean
	className?: string
	children?: ReactNode
	'aria-label'?: string
}

export function ToggleButton ({
	value,
	label,
	iconLeft,
	iconRight,
	iconOnly,
	disabled,
	className,
	children,
	'aria-label': ariaLabel
}: ToggleButtonProps) {
	const group = useToggleButtonGroup()
	if (!group) return null

	const isActive = Array.isArray(group.value)
		? group.value.includes(value)
		: group.value === value
	const toggleSpacesClass = [
		'spaces-toggle',
		isActive && 'spaces-active',
		disabled && 'spaces-disabled'
	]
		.filter(Boolean)
		.join(' ')

	return (
		<Button
			label={label ?? (children as string)}
			iconLeft={iconLeft}
			iconRight={iconRight}
			iconOnly={iconOnly}
			size={group.size}
			appearance={isActive ? group.activeAppearance : group.inactiveAppearance}
			color={isActive ? group.activeColor : group.inactiveColor}
			disabled={disabled}
			onClick={() => group.onValueChange(value)}
			spacesClass={toggleSpacesClass}
			className={className}
			aria-label={ariaLabel}
		/>
	)
}
